/**
* Intended for universal functions that contain knowledge of the app architecture. For
* general utility functions (that have no dependencies) please see Utilities.js mixin
*/
export default {
	data() {
		return {
			provincesList: [{text: "Alberta",value: "AB"},{text: "British Columbia",value: "BC"},{text: "Manitoba",value: "MB"},{text: "New Brunswick",value: "NB"},{text: "Newfoundland and Labrador",value: "NL"},{text: "Northwest Territories",value: "NT"},{text: "Nova Scotia",value: "NS"},{text: "Nunavut",value: "NU"},{text: "Ontario",value: "ON"},{text: "Prince Edward Island",value: "PE"},{text: "Quebec",value: "QC"},{text: "Saskatchewan",value: "SK"},{text: "Yukon",value: "YT"}],
			statesList: [{text: 'Alabama',value: 'AL'},{text: 'Alaska',value: 'AK'},{text: 'American Samoa',value: 'AS'},{text: 'Arizona',value: 'AZ'},{text: 'Arkansas',value: 'AR'},{text: 'California',value: 'CA'},{text: 'Colorado',value: 'CO'},{text: 'Connecticut',value: 'CT'},{text: 'Delaware',value: 'DE'},{text: 'District of Columbia',value: 'DC'},{text: 'Federated States of Micronesia',value: 'FM'},{text: 'Florida',value: 'FL'},{text: 'Georgia',value: 'GA'},{text: 'Guam',value: 'GU'},{text: 'Hawaii',value: 'HI'},{text: 'Idaho',value: 'ID'},{text: 'Illinois',value: 'IL'},{text: 'Indiana',value: 'IN'},{text: 'Iowa',value: 'IA'},{text: 'Kansas',value: 'KS'},{text: 'Kentucky',value: 'KY'},{text: 'Louisiana',value: 'LA'},{text: 'Maine',value: 'ME'},{text: 'Marshall Islands',value: 'MH'},{text: 'Maryland',value: 'MD'},{text: 'Massachusetts',value: 'MA'},{text: 'Michigan',value: 'MI'},{text: 'Minnesota',value: 'MN'},{text: 'Mississippi',value: 'MS'},{text: 'Missouri',value: 'MO'},{text: 'Montana',value: 'MT'},{text: 'Nebraska',value: 'NE'},{text: 'Nevada',value: 'NV'},{text: 'New Hampshire',value: 'NH'},{text: 'New Jersey',value: 'NJ'},{text: 'New Mexico',value: 'NM'},{text: 'New York',value: 'NY'},{text: 'North Carolina',value: 'NC'},{text: 'North Dakota',value: 'ND'},{text: 'Northern Mariana Islands',value: 'MP'},{text: 'Ohio',value: 'OH'},{text: 'Oklahoma',value: 'OK'},{text: 'Oregon',value: 'OR'},{text: 'Palau',value: 'PW'},{text: 'Pennsylvania',value: 'PA'},{text: 'Puerto Rico',value: 'PR'},{text: 'Rhode Island',value: 'RI'},{text: 'South Carolina',value: 'SC'},{text: 'South Dakota',value: 'SD'},{text: 'Tennessee',value: 'TN'},{text: 'Texas',value: 'TX'},{text: 'Utah',value: 'UT'},{text: 'Vermont',value: 'VT'},{text: 'Virgin Island',value: 'VI'},{text: 'Virginia',value: 'VA'},{text: 'Washington',value: 'WA'},{text: 'West Virginia',value: 'WV'},{text: 'Wisconsin',value: 'WI'},{text: 'Wyoming',value: 'WY'}],
			countriesList: [{text: 'Afghanistan', value: 'AF'}, {text: 'Albania', value: 'AL'}, {text: 'Algeria', value: 'DZ'}, {text: 'American Samoa', value: 'AS'}, {text: 'Andorra', value: 'AD'}, {text: 'Angola', value: 'AO'}, {text: 'Anguilla', value: 'AI'}, {text: 'Antarctica', value: 'AQ'}, {text: 'Antigua and Barbuda', value: 'AG'}, {text: 'Argentina', value: 'AR'}, {text: 'Armenia', value: 'AM'}, {text: 'Aruba', value: 'AW'}, {text: 'Australia', value: 'AU'}, {text: 'Austria', value: 'AT'}, {text: 'Azerbaijan', value: 'AZ'}, {text: 'Bahamas (the)', value: 'BS'}, {text: 'Bahrain', value: 'BH'}, {text: 'Bangladesh', value: 'BD'}, {text: 'Barbados', value: 'BB'}, {text: 'Belarus', value: 'BY'}, {text: 'Belgium', value: 'BE'}, {text: 'Belize', value: 'BZ'}, {text: 'Benin', value: 'BJ'}, {text: 'Bermuda', value: 'BM'}, {text: 'Bhutan', value: 'BT'}, {text: 'Bolivia (Plurinational State of)', value: 'BO'}, {text: 'Bonaire, Sint Eustatius and Saba', value: 'BQ'}, {text: 'Bosnia and Herzegovina', value: 'BA'}, {text: 'Botswana', value: 'BW'}, {text: 'Bouvet Island', value: 'BV'}, {text: 'Brazil', value: 'BR'}, {text: 'British Indian Ocean Territory (the)', value: 'IO'}, {text: 'Brunei Darussalam', value: 'BN'}, {text: 'Bulgaria', value: 'BG'}, {text: 'Burkina Faso', value: 'BF'}, {text: 'Burundi', value: 'BI'}, {text: 'Cabo Verde', value: 'CV'}, {text: 'Cambodia', value: 'KH'}, {text: 'Cameroon', value: 'CM'}, {text: 'Canada', value: 'CA'}, {text: 'Cayman Islands (the)', value: 'KY'}, {text: 'Central African Republic (the)', value: 'CF'}, {text: 'Chad', value: 'TD'}, {text: 'Chile', value: 'CL'}, {text: 'China', value: 'CN'}, {text: 'Christmas Island', value: 'CX'}, {text: 'Cocos (Keeling) Islands (the)', value: 'CC'}, {text: 'Colombia', value: 'CO'}, {text: 'Comoros (the)', value: 'KM'}, {text: 'Congo (the Democratic Republic of the)', value: 'CD'}, {text: 'Congo (the)', value: 'CG'}, {text: 'Cook Islands (the)', value: 'CK'}, {text: 'Costa Rica', value: 'CR'}, {text: 'Croatia', value: 'HR'}, {text: 'Cuba', value: 'CU'}, {text: 'Curaçao', value: 'CW'}, {text: 'Cyprus', value: 'CY'}, {text: 'Czechia', value: 'CZ'}, {text: "Côte d'Ivoire", value: 'CI'}, {text: 'Denmark', value: 'DK'}, {text: 'Djibouti', value: 'DJ'}, {text: 'Dominica', value: 'DM'}, {text: 'Dominican Republic (the)', value: 'DO'}, {text: 'Ecuador', value: 'EC'}, {text: 'Egypt', value: 'EG'}, {text: 'El Salvador', value: 'SV'}, {text: 'Equatorial Guinea', value: 'GQ'}, {text: 'Eritrea', value: 'ER'}, {text: 'Estonia', value: 'EE'}, {text: 'Eswatini', value: 'SZ'}, {text: 'Ethiopia', value: 'ET'}, {text: 'Falkland Islands (the) [Malvinas]', value: 'FK'}, {text: 'Faroe Islands (the)', value: 'FO'}, {text: 'Fiji', value: 'FJ'}, {text: 'Finland', value: 'FI'}, {text: 'France', value: 'FR'}, {text: 'French Guiana', value: 'GF'}, {text: 'French Polynesia', value: 'PF'}, {text: 'French Southern Territories (the)', value: 'TF'}, {text: 'Gabon', value: 'GA'}, {text: 'Gambia (the)', value: 'GM'}, {text: 'Georgia', value: 'GE'}, {text: 'Germany', value: 'DE'}, {text: 'Ghana', value: 'GH'}, {text: 'Gibraltar', value: 'GI'}, {text: 'Greece', value: 'GR'}, {text: 'Greenland', value: 'GL'}, {text: 'Grenada', value: 'GD'}, {text: 'Guadeloupe', value: 'GP'}, {text: 'Guam', value: 'GU'}, {text: 'Guatemala', value: 'GT'}, {text: 'Guernsey', value: 'GG'}, {text: 'Guinea', value: 'GN'}, {text: 'Guinea-Bissau', value: 'GW'}, {text: 'Guyana', value: 'GY'}, {text: 'Haiti', value: 'HT'}, {text: 'Heard Island and McDonald Islands', value: 'HM'}, {text: 'Holy See (the)', value: 'VA'}, {text: 'Honduras', value: 'HN'}, {text: 'Hong Kong', value: 'HK'}, {text: 'Hungary', value: 'HU'}, {text: 'Iceland', value: 'IS'}, {text: 'India', value: 'IN'}, {text: 'Indonesia', value: 'ID'}, {text: 'Iran (Islamic Republic of)', value: 'IR'}, {text: 'Iraq', value: 'IQ'}, {text: 'Ireland', value: 'IE'}, {text: 'Isle of Man', value: 'IM'}, {text: 'Israel', value: 'IL'}, {text: 'Italy', value: 'IT'}, {text: 'Jamaica', value: 'JM'}, {text: 'Japan', value: 'JP'}, {text: 'Jersey', value: 'JE'}, {text: 'Jordan', value: 'JO'}, {text: 'Kazakhstan', value: 'KZ'}, {text: 'Kenya', value: 'KE'}, {text: 'Kiribati', value: 'KI'}, {text: "Korea (the Democratic People's Republic of)", value: 'KP'}, {text: 'Korea (the Republic of)', value: 'KR'}, {text: 'Kuwait', value: 'KW'}, {text: 'Kyrgyzstan', value: 'KG'}, {text: "Lao People's Democratic Republic (the)", value: 'LA'}, {text: 'Latvia', value: 'LV'}, {text: 'Lebanon', value: 'LB'}, {text: 'Lesotho', value: 'LS'}, {text: 'Liberia', value: 'LR'}, {text: 'Libya', value: 'LY'}, {text: 'Liechtenstein', value: 'LI'}, {text: 'Lithuania', value: 'LT'}, {text: 'Luxembourg', value: 'LU'}, {text: 'Macao', value: 'MO'}, {text: 'Madagascar', value: 'MG'}, {text: 'Malawi', value: 'MW'}, {text: 'Malaysia', value: 'MY'}, {text: 'Maldives', value: 'MV'}, {text: 'Mali', value: 'ML'}, {text: 'Malta', value: 'MT'}, {text: 'Marshall Islands (the)', value: 'MH'}, {text: 'Martinique', value: 'MQ'}, {text: 'Mauritania', value: 'MR'}, {text: 'Mauritius', value: 'MU'}, {text: 'Mayotte', value: 'YT'}, {text: 'Mexico', value: 'MX'}, {text: 'Micronesia (Federated States of)', value: 'FM'}, {text: 'Moldova (the Republic of)', value: 'MD'}, {text: 'Monaco', value: 'MC'}, {text: 'Mongolia', value: 'MN'}, {text: 'Montenegro', value: 'ME'}, {text: 'Montserrat', value: 'MS'}, {text: 'Morocco', value: 'MA'}, {text: 'Mozambique', value: 'MZ'}, {text: 'Myanmar', value: 'MM'}, {text: 'Namibia', value: 'NA'}, {text: 'Nauru', value: 'NR'}, {text: 'Nepal', value: 'NP'}, {text: 'Netherlands (the)', value: 'NL'}, {text: 'New Caledonia', value: 'NC'}, {text: 'New Zealand', value: 'NZ'}, {text: 'Nicaragua', value: 'NI'}, {text: 'Niger (the)', value: 'NE'}, {text: 'Nigeria', value: 'NG'}, {text: 'Niue', value: 'NU'}, {text: 'Norfolk Island', value: 'NF'}, {text: 'Northern Mariana Islands (the)', value: 'MP'}, {text: 'Norway', value: 'NO'}, {text: 'Oman', value: 'OM'}, {text: 'Pakistan', value: 'PK'}, {text: 'Palau', value: 'PW'}, {text: 'Palestine, State of', value: 'PS'}, {text: 'Panama', value: 'PA'}, {text: 'Papua New Guinea', value: 'PG'}, {text: 'Paraguay', value: 'PY'}, {text: 'Peru', value: 'PE'}, {text: 'Philippines (the)', value: 'PH'}, {text: 'Pitcairn', value: 'PN'}, {text: 'Poland', value: 'PL'}, {text: 'Portugal', value: 'PT'}, {text: 'Puerto Rico', value: 'PR'}, {text: 'Qatar', value: 'QA'}, {text: 'Republic of North Macedonia', value: 'MK'}, {text: 'Romania', value: 'RO'}, {text: 'Russian Federation (the)', value: 'RU'}, {text: 'Rwanda', value: 'RW'}, {text: 'Réunion', value: 'RE'}, {text: 'Saint Barthélemy', value: 'BL'}, {text: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH'}, {text: 'Saint Kitts and Nevis', value: 'KN'}, {text: 'Saint Lucia', value: 'LC'}, {text: 'Saint Martin (French part)', value: 'MF'}, {text: 'Saint Pierre and Miquelon', value: 'PM'}, {text: 'Saint Vincent and the Grenadines', value: 'VC'}, {text: 'Samoa', value: 'WS'}, {text: 'San Marino', value: 'SM'}, {text: 'Sao Tome and Principe', value: 'ST'}, {text: 'Saudi Arabia', value: 'SA'}, {text: 'Senegal', value: 'SN'}, {text: 'Serbia', value: 'RS'}, {text: 'Seychelles', value: 'SC'}, {text: 'Sierra Leone', value: 'SL'}, {text: 'Singapore', value: 'SG'}, {text: 'Sint Maarten (Dutch part)', value: 'SX'}, {text: 'Slovakia', value: 'SK'}, {text: 'Slovenia', value: 'SI'}, {text: 'Solomon Islands', value: 'SB'}, {text: 'Somalia', value: 'SO'}, {text: 'South Africa', value: 'ZA'}, {text: 'South Georgia and the South Sandwich Islands', value: 'GS'}, {text: 'South Sudan', value: 'SS'}, {text: 'Spain', value: 'ES'}, {text: 'Sri Lanka', value: 'LK'}, {text: 'Sudan (the)', value: 'SD'}, {text: 'Suriname', value: 'SR'}, {text: 'Svalbard and Jan Mayen', value: 'SJ'}, {text: 'Sweden', value: 'SE'}, {text: 'Switzerland', value: 'CH'}, {text: 'Syrian Arab Republic', value: 'SY'}, {text: 'Taiwan', value: 'TW'}, {text: 'Tajikistan', value: 'TJ'}, {text: 'Tanzania, United Republic of', value: 'TZ'}, {text: 'Thailand', value: 'TH'}, {text: 'Timor-Leste', value: 'TL'}, {text: 'Togo', value: 'TG'}, {text: 'Tokelau', value: 'TK'}, {text: 'Tonga', value: 'TO'}, {text: 'Trinidad and Tobago', value: 'TT'}, {text: 'Tunisia', value: 'TN'}, {text: 'Turkey', value: 'TR'}, {text: 'Turkmenistan', value: 'TM'}, {text: 'Turks and Caicos Islands (the)', value: 'TC'}, {text: 'Tuvalu', value: 'TV'}, {text: 'Uganda', value: 'UG'}, {text: 'Ukraine', value: 'UA'}, {text: 'United Arab Emirates (the)', value: 'AE'}, {text: 'United Kingdom of Great Britain and Northern Ireland (the)', value: 'GB'}, {text: 'United States Minor Outlying Islands (the)', value: 'UM'}, {text: 'United States of America (the)', value: 'USA'}, {text: 'Uruguay', value: 'UY'}, {text: 'Uzbekistan', value: 'UZ'}, {text: 'Vanuatu', value: 'VU'}, {text: 'Venezuela (Bolivarian Republic of)', value: 'VE'}, {text: 'Viet Nam', value: 'VN'}, {text: 'Virgin Islands (British)', value: 'VG'}, {text: 'Virgin Islands (U.S.)', value: 'VI'}, {text: 'Wallis and Futuna', value: 'WF'}, {text: 'Western Sahara', value: 'EH'}, {text: 'Yemen', value: 'YE'}, {text: 'Zambia', value: 'ZM'}, {text: 'Zimbabwe', value: 'ZW'}, {text: 'Åland Islands', value: 'AX'}],

			debounceTimer: null,
			modelMap: {
				Expense: "Expense",
				TimeLog: "Time Log",
				Service: "Service",
				PurchaseOrder: "Purchase Order",
				Contact: "Contact",
				ServiceInvoice: "Service Invoice/Quote",
				LibraryFile: "Library File",
				Equipment: "Equipment",
				UserCompanyCertificate: "Training Certificate",
				ServiceContract: "Service Contract"
			},
			documentIdMap: {
				ServiceInvoiceObject: "invoice_id",
				JobChangeOrderObject: "quote_id",
				JobBidComponentObject: "bid_component_id"
			}
		}
	},
	computed: {
		globalInvoiceSettings() {
			let settings = {}

			try {
				settings = JSON.parse(this.$store.company.CompanySetting.job_defaults_json)
			}
			catch (e) {}

			return settings
		},
		companyIsAmerican() {
			let usaNames = ["america","united states","usa","united states of america","us"]

			if ("country" in this.$store.company && usaNames.indexOf(this.$store.company.country.toLowerCase()) >= 0)
				return true

			return false
		},
		checkinToleranceLabel() {
			if (this.companyIsAmerican)
				return "Check In Tolerance"

			return "Check In Tolerance"
		},
		qboIsActive() {
			return 'CompanySetting' in this.$store.company && this.$store.company.CompanySetting && this.$store.company.CompanySetting.qbo_active == 1
		},
		isFreemiumUser() {
			if (this.$store.company && "is_freemium" in this.$store.company) 
				return this.$store.company.is_freemium == 1
			
			return false
		},
		hasPaidSubscription() {
			if (this.$store.company.is_free_user == 1)
				return true

			if (this.$store.subscription.type == 'Paid' && this.moment(this.$store.subscription.expiry).isAfter(this.moment()))
				return true

			return false
		},
		hasOnboardingPackage() {
			if (this.$store.company.onboarding_package_purchased_id > 0)
				return true

			return false
		},
		salesTaxes() {
			let taxes = []

			try {
				let taxesObjs = JSON.parse(this.$store.company.CompanySetting.taxes_json)

				Object.keys(taxesObjs).forEach(key => {

					let taxRateValue
					if (typeof taxes[key] == 'object') 
						taxRateValue = taxes[key].taxRate
					else
						taxRateValue = taxes[key]

					taxes.push({
						label: key,
						rate: taxRateValue
					})
				})
			}
			catch (e) {}

			return taxes
		}
	},
	methods: {
		spinner(show,msg) {
			this.$bus.$emit("spinner",show,msg)
		},
		alertFail(msg,selfClear) {
			this.$bus.$emit("pushAlert",{
				message: msg,
				icon: "fa-exclamation-triangle",
				timestamp: Date.now(),
				class: "alert-danger",
				selfClear: selfClear
			})
		},
		alertErrors(errors,selfClear) {

			if (typeof errors == 'object' && Object.keys(errors).length == 1) {

				this.$bus.$emit("pushAlert",{
					message: errors[Object.keys(errors)[0]],
					icon: "fa-exclamation-triangle",
					timestamp: Date.now(),
					class: "alert-danger",
					selfClear: selfClear
				})
			}
			else {
				this.$bus.$emit("pushAlert",{
					message: "There were some errors: ",
					icon: "fa-exclamation-triangle",
					timestamp: Date.now(),
					class: "alert-danger",
					selfClear: selfClear,
					errors: errors
				})
			}
		},
		throwPremiumFeatureError() {
			this.alertFail("This is a paid feature. <a href='https://tradetraks.ca' target='_blank'>Book a Demo</a> to see what Tradetraks has to offer")
		},
		debounce(actionFunction,arg,delay) {
			let vm = this

			if (!delay)
				delay = 250

			clearTimeout(this.debounceTimer)

			this.debounceTimer = setTimeout(() => {
				if (actionFunction in vm)
					vm[actionFunction](arg) //call it as a method of the vue instance
				else
					actionFunction(arg) //call it as aregular function

				vm.debounceTimer = false
			},delay)
		
		},
		isOnline(lastActive,seconds) {
			if (seconds)
				return this.moment().diff(this.moment(lastActive),"seconds") < seconds
			else
				return this.moment().diff(this.moment(lastActive),"seconds") < 60
		},
		alertSuccess(msg,selfClear) {

			if (typeof selfClear == 'undefined')
				selfClear = true

			this.$bus.$emit("pushAlert",{
				message: msg,
				icon: "fa-check",
				timestamp: Date.now(),
				class: "alert-success",
				selfClear: selfClear,
				clearPrevious: true
			})
		},
		alertSaved(msg,selfClear) {
			if (typeof selfClear == 'undefined')
				selfClear = true

			if (!msg)
				msg = "Record Saved!"

			this.$bus.$emit("pushAlert",{
				message: msg,
				icon: "fa-save",
				timestamp: Date.now(),
				class: "alert-success",
				selfClear: selfClear,
				clearPrevious: true
			})
		},
		alertInfo(msg,selfClear) {

			this.$bus.$emit("pushAlert",{
				message: msg,
				icon: "fa-info",
				timestamp: Date.now(),
				class: "alert-info",
				selfClear: selfClear
			})
		},
		clockInTimeElapsed() {
			let localTimeIn = this.moment.utc(this.$store.clockinTime).local()

			let duration = this.moment.duration(this.moment().diff(localTimeIn))

			let min = duration.minutes()

			if (min < 10)
				min = "0"+min

			let hrs = duration.hours()

			let sec = duration.seconds()

			if (sec < 0)
				return "Out of Sync"
			if (sec < 10)
				sec = "0"+sec

			if (isNaN(hrs) || isNaN(min) || isNaN(sec)) { //prevent ugly NaN:NaN:NaN flash
				return "Out of Sync"
			}

			return hrs+":"+min+":"+sec
		},
		getLocation() {
			let vm = this


			function renderPosition(navigatorResponse) {
				let position = {
					lat: navigatorResponse.coords.latitude,
					lng: navigatorResponse.coords.longitude,
					accuracy: navigatorResponse.coords.accuracy
				}

				return position
			}

			return new Promise((resolve,reject) => {

				//for testing

				if (window.environment == 'xDevelopment') {

					let position = {
						lat: 42.2130076,
						lng: -79.956533,
						accuracy: 1005
					}

					vm.$store.latestPosition = position

					resolve(position)

				}
				else {
					navigator.geolocation.getCurrentPosition(navigatorResponse => {

						let thePosition = renderPosition(navigatorResponse)

						vm.$store.latestPosition = thePosition

						resolve(thePosition)
					},
					error => {
						navigator.geolocation.getCurrentPosition(navigatorResponse => {

							let thePosition = renderPosition(navigatorResponse)

							vm.$store.latestPosition = thePosition

							resolve(thePosition)
						},
						error => {
							reject(error)
						},
						{
							timeout: 5000
						})
					},
					{
						timeout: 3000
					})
				}
			})
		},
		convertToRegionalUnits(value,unit,rounding = 1) {
			let converted, conversionRatio, convertedUnit

			// Early guard for undefined/null/bad input
			if (value === undefined || value === null || isNaN(+value)) {
				return {
					value: '[Unknown]',
					unit: unit || ''
				}
			}

			if (this.companyIsAmerican) {
				if (unit == "km") {
					conversionRatio = 0.6211
					convertedUnit = "mi"
				}
				else if (unit == 'm') {
					conversionRatio = 3.281
					convertedUnit = "ft"
				}
				converted = +value * conversionRatio

				return {
					value: converted.round(rounding),
					unit: convertedUnit
				}
			}

			if (typeof value == 'string') {
				return {
					value,
					unit
				}
			}

			return {
				value: value.round(rounding),
				unit
			}
		},
		setSessionToken() {

			let token = {}

			let fetchNeeded = false
			try {
				token = JSON.parse(localStorage.sessionToken)

				//check if token is expired
				if (this.moment().isAfter(this.moment.utc(token.expiry))) {
					//fetch new token
					fetchNeeded = true
				}
				else {
					this.$store.sessionToken = token.token
					this.$store.sessionTokenExpiry = token.expiry
				}
			}
			catch (e) {
				fetchNeeded = true
			}

			return new Promise((resolve,reject) => {

				if (fetchNeeded) {
					let vm = this
					vm.postData("UserToken/create",{user_id:vm.$store.userDetails.id,expiry_hrs:12}).then(response => {
						if (response.success) {
							localStorage.sessionToken = JSON.stringify(response.data)

							vm.$store.sessionToken = response.data.token
							vm.$store.sessionTokenExpiry = response.data.expiry
						}
						resolve(response)
					})
				}
				else
					resolve(false)

			})

		},
		/**
		*	This will take a set of nav items, and filter them down depending on user permissions
		*	Requires: $root.userModulePerms (obj), $root.userRole (string, Admin/Basic)
		*	Parameter: items, a nav item array
		*
		*	to restrict to Admins only, property of adminRequired: true must be set on array item
		*	to restrict by module, property of modulePermRequired: "moduleName" must be set on array item
		*
		*	NOTE: This only checks READ permissions, write permissions should be handled inside the destination view
		**/
		filterNavForPerms(items) {
			let vm = this

			let filtered = items.filter((item,index) => {

				if (!("link" in item) && !("path" in item))
					return true

				//filter time logs item explicitly
				if (item.link == "/time-logs/review") {
					//now let's check if the time-log/review should be removed, based on user's JobPersonnelRoles
					let include = false

					vm.$store.userDetails.JobPersonnelRole.forEach(role => {

						if (role.review_timelogs ==1)
							include = true
					})
					if (include)
						return true
				}

				// Project RFIs tab: JobPersonnelRole.write_rfis grants the tab when user lacks RFIs module read (same idea as /time-logs/review + review_timelogs)
				if ("path" in item && typeof item.path == "string" && item.path.indexOf("/project/") === 0 && item.path.indexOf("/rfis", item.path.length - 5) === item.path.length - 5) {
					if (!vm.hasModulePermRead("RFIs") && vm.$store.project && vm.$store.project.id && "JobPersonnelRole" in vm.$store.userDetails && vm.$store.userDetails.JobPersonnelRole) {
						let writeRfiRole = vm.$store.userDetails.JobPersonnelRole.find(role => role.job_id == vm.$store.project.id && "write_rfis" in role && role.write_rfis == 1)
						if (writeRfiRole)
							return true
					}
				}

				if (vm.$store.userRole == "Admin")
					return true;

				if ("adminRequired" in item) {
					if (vm.$store.userRole != "Admin")
						return false
				}

				if ("modulePermRequired" in item) {
					if (typeof item.modulePermRequired == "string") {
						//just one module
						if (item.modulePermRequired in vm.$store.userModulePerms) {

							if (vm.$store.userModulePerms[item.modulePermRequired].read)
								return true
							else
								return false
						}
						else 
							return false
					}
					else {

						//this is an array of multiple modules
						let hasPerm = true
						item.modulePermRequired.forEach(mod => {
							if (!vm.hasModulePermRead(mod))
								hasPerm = false
						})

						return hasPerm
						
					}
				}
				else if ("anyModulePerms" in item) {
					let hasPerm = false
					item.anyModulePerms.forEach(mod => {
						if (vm.hasModulePermRead(mod))
							hasPerm = true
					})

					return hasPerm
					
				}

				return true
			})
			
			return filtered
		},
		hasActiveEmployer() {
			if (this.$store.userDetails.tenant_id > 0)
				return true
			else 
				return false
		},
		isOnActiveEmployer() {

			if (Object.keys(this.getUserModulePerms()).length == 0 && !this.getUserRoleType())
				return false
			else
				return true
		},
		getUserRoleType() {
			if (this.$store.userDetails.UserPermission && this.$store.userDetails.UserPermission.length > 0 && this.$store.userDetails.UserPermission[0].is_inactive == 0)
				return this.$store.userDetails.UserPermission[0].role_type
			else
				return false
		},
		getUserModulePerms() {
			let vm = this

			if (this.$store.userDetails.UserPermission && this.$store.userDetails.UserPermission.length > 0 && this.$store.userDetails.UserPermission[0].is_inactive == 0) {
				let userPermissions = this.$store.userDetails.UserPermission[0]

				let modulePerms = userPermissions.module_permissions == "" ? {} : JSON.parse(userPermissions.module_permissions)

				return modulePerms
			}
			else
				return {}
		},
		hasRoleBasedPermission(jobType,jobId,permission) {
			let jobKey = "job_id"
			if (jobType.toLowerCase() == 'service')
				jobKey = "service_id"

			let found = this.$store.userDetails.JobPersonnelRole.find(perm => perm[jobKey] == jobId && perm[permission] == 1)

			return found
		},
		hasReviewTimeLogsOnJob() {
			let jobPersonnelRoles = this.$store.userDetails.JobPersonnelRole

			let hasReviewTimegLogsOnJob = false

			jobPersonnelRoles.forEach(role => {
				if (role.review_timelogs == 1)
					hasReviewTimeLogsOnJob = true
			})

			return hasReviewTimeLogsOnJob
		},
		hasModulePermWrite(module) {
			let perms = this.getUserModulePerms()

			if (this.getUserRoleType() == 'Admin')
				return true

			if (module in perms) {
				let mod = perms[module]

				if ("write" in mod && mod.write)
					return true
				else
					return false
			}
			else
				return false
		},
		hasModulePermRead(module) {
			let perms = this.getUserModulePerms()

			if (this.getUserRoleType() == 'Admin')
				return true

			if (module in perms) {
				let mod = perms[module]

				if ("read" in mod && mod.read)
					return true
				else
					return false
			}
			else return false
		},
		userIsServiceTech() {
			if ("CompanySettings" in this.$store.userDetails && this.$store.userDetails.CompanySettings && this.$store.userDetails.CompanySettings.is_service_tech == 1)
				return true
			else if (this.$store.userDetails.hasServiceJobsAssigned)
				return true
			else
				return false
		},
		fetchReviewableLogs() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("TimeLog/count-reviewable-logs").then(logResponse => {
					vm.reviewableLogsFetched = true

					if (logResponse.success) {
						vm.numTimeLogsToReview = logResponse.data.timeLogs
						vm.numExpensesToReview = logResponse.data.expenses
						vm.$store.numTimeLogsToReview = logResponse.data.timeLogs
						vm.$store.numExpensesToReview = logResponse.data.expenses
					}

					if (!vm.$store.reviewAlertModalShown && (vm.numTimeLogsToReview > 0 || vm.numExpensesToReview > 0)) {
						vm.modalDialogVisible = true
						vm.$store.reviewAlertModalShown = true
					}

					resolve(logResponse)
				})
			})
		},
		/**
		* Checks for any new messages across all threads (to show red bubble)
		*/
		checkNewMessages() {
			let vm = this

			if (!this.$store.checkingMessages) {
				this.$store.checkingMessages = true

				this.$bus.$emit("checkNewMessages")

				vm.getJSON("Message/check-new").then(response => {
					//console.log("App: Checked for new messages at "+response.time)
					vm.$store.checkingMessages = false
					if (response.success) {
						vm.$store.threadsWithNewMessages = response.data.threads

						if (vm.$store.threadsWithNewMessages.length > 0)
							vm.$bus.$emit("newMessages",true)

						vm.$bus.$emit("userActivityUpdate",response.data.users)

						if (vm.$store.threadsWithNewMessages.length != vm.$store.unreadMessageThreads.length) {
							//fetch threads with new messages

							if (vm.$store.threadsWithNewMessages && vm.$store.threadsWithNewMessages.length > 0) {
								let unreadParams = {
									filters: [
										["id",vm.$store.threadsWithNewMessages]
									],
									include: [
										{model:"User",fields:["id","slug","first_name","last_name","image_id"]},
										{model:"Job",fields:["id","slug","job_num","job_name"]},
										{model:"Service",fields:["id","slug","job_num","job_name"]}
										//{model:"Message",limit:1}
									]
								}

								vm.postData("MessageThread/get",unreadParams).then(threadResponse => {

									if (threadResponse.success) 
										vm.$store.unreadMessageThreads = threadResponse.data
									
								})
							}
						}
					}			
				})
			}
		},
		attachImageToThread(thread, profileImages) {
			if (thread && "Members" in thread) {

				let image_id = 0;
				thread.Members.forEach(member => {
					if (member.id == thread.last_message_by) 
						image_id = member.image_id
					
				})

				profileImages.forEach(image => {

					if (image && image.id == image_id) {
						let slug = image.slug
						let filename = image.filename

						thread.imageUrl = window.apiRoot+"resources/profile-images/"+slug+"/"+filename
					}
				})
			}
			else if (thread)
				thread.Members = []

			return thread
		},
		getTotalTaxRate(companySettings,appliedTaxesJson) {
			let taxRate = 0, taxes = {}

			if (appliedTaxesJson) {
				try {
					taxes = JSON.parse(appliedTaxesJson)
				}
				catch (e) {}
			}
			else {
				try {
					taxes = JSON.parse(companySettings.taxes_json)

					let filteredTaxes = {}
					Object.keys(taxes).forEach(key => {
						//only get defaults if taxes_json is using new default settings
						if (typeof taxes == 'object') {
							if (taxes.isDefault == 1)
								filteredTaxes[key] = taxes[key]
						}
					})
					taxes = filteredTaxes
					
				}
				catch (e) {}
			}

			Object.keys(taxes).forEach(key => {
				let taxRateValue = 0

				if (typeof taxes[key] == 'object') 
					taxRateValue = taxes[key].taxRate
				else
					taxRateValue = taxes[key]

				taxRate += +taxRateValue
			})

			return taxRate
		},
		/**
		* elementKey = Material, Equipment, Labour, SupplierQuote
		* typeKey = price_adjustment, markup
		*/
		getDefaultPriceSetting(elementKey,typeKey) {
			let pricingObj = false

			try {
				pricingObj = JSON.parse(this.$store.company.CompanySetting.default_pricing_json)
			}
			catch (e) {}

			if (pricingObj && elementKey in pricingObj && pricingObj[elementKey] && typeKey in pricingObj[elementKey] && pricingObj[elementKey][typeKey]) {
				return +pricingObj[elementKey][typeKey]
			}
			return 1
		},
		buildName(obj) {
			if (!obj)
				return ""
			else if ('name' in obj && obj.name)
				return obj.name

			let tokens = []
			if ('first_name' in obj && obj.first_name)
				tokens.push(obj.first_name)
			if ('last_name' in obj && obj.last_name)
				tokens.push(obj.last_name)

			return tokens.join(' ')
		},
		clearStore() {
			let vm = this

			this.$store.project = {}
			this.$store.service = {}
			this.$store.equipmentItem = {}
			this.$store.timeLogSettings = {}
			this.$store.company = {}
			this.$store.contact = {}
			this.$store.employee = {}
			this.$store.companySetupMode = false
			this.$store.accountSetupMode = false
			
			this.$store.threadsWithNewMessages = []
			this.$store.unreadMessageThreads = []
			this.$store.threadList = []
			this.$store.jobsWithThreads = []
			this.$store.profileImages = []
			this.$store.employeeClassifications = []
			this.$store.payBoosts = []
			this.$store.customers = []
			this.$store.customerOptions = []
			this.$store.relevantProjects = []
			this.$store.lastListedProjects = []
			this.$store.jobPersonnelRoles = []
			this.$store.services = []
			this.$store.serviceWorkOrders = []
			this.$store.categories = []
			this.$store.revenueCodes = []
			this.$store.expenseGroups = []
			this.$store.expenseCodes = []
			this.$store.collectiveAgreementOptions = []
			this.$store.collectiveAgreements = []
			this.$store.errorList = []
			this.$store.clockedInJob = false;
			this.$store.subscription = {}
			this.$store.companyFormTemplateCategories = []
			this.$store.serviceContract = {}
			this.$store.materialsUsed = []
			this.$store.workOrder = {}
			this.$store.projects = []
			this.$store.projectUnionCollectiveAgreements = []
			this.$store.contactsIndividuals = []
			this.$store.unions = []

		},
		/* Work in Progress */
		notificationLinkBuilder(module_name,module_slug,resource,resource_slug) {
			//maps API module names to route segments
			let moduleMap = {
				"Projects" : "project",
				"Services" : "service",
			}

			let resourceMaps

			let link = "/"
			if (module_name && module_slug) {
				link += moduleMap[module_name]+"/"+module_slug
			}
			else if (module_name) {
				moduleMap = {
					"Projects" : "projects",
					"Services" : "services",
				}

				link += moduleMap[module_name]
			}

			if (resource && resource_slug) {

			}
			else if (resource) {

			}
		},
		buildRedirectLink(type, record_slug) {
			/**
			 * type is one of:
			 *    project
			 *    service
			 *    equipment
			 *    customer-asset
			 *    user-profile
			 *    company-link
			 */
			return window.location.origin + "/redirect/" + type + "/" + record_slug
		},
		downloadUserContact_old(user) {

			const fields = {
				email: 'EMAIL;PREF=1',
				//phone: 'TEL;TYPE=home',              // dont include home phone for privacy reasons
				phone_mobile: 'TEL;PREF=1;TYPE=cell',
				job_title: 'TITLE'
			}

			let vcard = "BEGIN:VCARD\nVERSION:4.0\n"
			vcard += "KIND:individual\n"

			// Add general fields
			Object.keys(fields).filter(key => {
				if (key in user && user[key]) {
					vcard += fields[key] + ":" + user[key] + "\n"
				}
			})


			// Add name
			let nameTokens = []
			if ('first_name' in user && user.first_name)
				nameTokens.push(user.first_name)
			if ('last_name' in user && user.last_name)
				nameTokens.push(user.last_name)

			const contactName = nameTokens.join(' ')
			vcard += "FN:" + contactName + "\n"

			const orderedName = nameTokens.reverse().join(';')
			vcard += "N:" + orderedName + "\n"


			// Begin prepping for images
			let userProfileImage = false
			let companyProfileImage = false


			// Add user profile image
			if ("ProfileImage" in user && user.ProfileImage && 'slug' in user.ProfileImage && user.ProfileImage.slug && 'filename' in user.ProfileImage && user.ProfileImage.filename)
				userProfileImage = window.apiRoot + "resources/profile-images/" + user.ProfileImage.slug + "/" + user.ProfileImage.filename


			// Add company details and logo
			if ('ActiveTenant' in user && user.ActiveTenant) {
				const company = user.ActiveTenant

				if ('company_name' in company && company.company_name)
					vcard += "ORG:" + company.company_name + "\n"
				if ('website' in company && company.website)
					vcard += "URL:" + company.website + "\n"
				if ("ProfileImage" in company && company.ProfileImage && 'slug' in company.ProfileImage && company.ProfileImage.slug && 'filename' in company.ProfileImage && company.ProfileImage.filename)
					companyProfileImage = this.apiRoot + "resources/profile-images/" + company.ProfileImage.slug + "/" + company.ProfileImage.filename
			}


			let promises = []
			if (userProfileImage)
				promises.push(this.getBase64ImageFromUrl(userProfileImage))
			if (companyProfileImage)
				promises.push(this.getBase64ImageFromUrl(companyProfileImage))

			Promise.all(promises).then(images => {

				const imageType = {
					'/': 'JPG',
					'i': 'PNG'
				}

				try {
					if (userProfileImage && images[0]) {
						images[0] = images[0].split(',')[1]  // remove annoying prefix
						if (images[0][0] in imageType)
							vcard += "PHOTO;ENCODING=BASE64;TYPE=" + imageType[images[0][0]] + ":" + images[0] + "\n"
					}
				} catch {}

				try {
					if (companyProfileImage && images[1]) {
						images[1] = images[1].replace('data:image/png;base64,', '')
						if (images[1][0] in imageType)
							vcard += "LOGO;ENCODING=BASE64;TYPE=" + imageType[images[1][0]] + ":" + images[1] + "\n"
					}
				} catch {}

				vcard += "END:VCARD"

				const blob = new Blob([vcard], { type: "text/vcard" });
				const url = URL.createObjectURL(blob);

				const newLink = document.createElement('a');
				newLink.download = contactName + ".vcf";
				newLink.textContent = contactName;
				newLink.href = url;
				newLink.click();
			})
		},
		downloadUserContact(user) {

			const fields = {
				email: 'EMAIL;PREF=1',
				//phone: 'TEL;TYPE=home',              // dont include home phone for privacy reasons
				phone_mobile: 'TEL;PREF=1;TYPE=cell',
				job_title: 'TITLE'
			}

			let vcard = "BEGIN:VCARD\nVERSION:4.0\n"
			vcard += "KIND:individual\n"

			// Add general fields
			Object.keys(fields).filter(key => {
				if (key in user && user[key]) {
					vcard += fields[key] + ":" + user[key] + "\n"
				}
			})


			// Add name
			let nameTokens = []
			if ('first_name' in user && user.first_name)
				nameTokens.push(user.first_name)
			if ('last_name' in user && user.last_name)
				nameTokens.push(user.last_name)

			const contactName = nameTokens.join(' ')
			vcard += "FN:" + contactName + "\n"

			const orderedName = nameTokens.reverse().join(';')
			vcard += "N:" + orderedName + "\n"


			// Begin prepping for images
			let userProfileImage = false
			let companyProfileImage = false


			// Add user profile image
			if ("ProfileImage" in user && user.ProfileImage && 'slug' in user.ProfileImage && user.ProfileImage.slug && 'filename' in user.ProfileImage && user.ProfileImage.filename)
				userProfileImage = window.apiRoot + "resources/profile-images/" + user.ProfileImage.slug + "/" + user.ProfileImage.filename


			// Add company details and logo
			if ('ActiveTenant' in user && user.ActiveTenant) {
				const company = user.ActiveTenant

				if ('company_name' in company && company.company_name)
					vcard += "ORG:" + company.company_name + "\n"
				if ('website' in company && company.website)
					vcard += "URL:" + company.website + "\n"
				if ("ProfileImage" in company && company.ProfileImage && 'slug' in company.ProfileImage && company.ProfileImage.slug && 'filename' in company.ProfileImage && company.ProfileImage.filename)
					companyProfileImage = this.apiRoot + "resources/profile-images/" + company.ProfileImage.slug + "/" + company.ProfileImage.filename
			}


			let promises = []
			if (userProfileImage)
				promises.push(this.getBase64ImageFromUrl(userProfileImage))
			if (companyProfileImage)
				promises.push(this.getBase64ImageFromUrl(companyProfileImage))

			Promise.all(promises).then(images => {

				const imageType = {
					'/': 'JPG',
					'i': 'PNG'
				}

				try {
					if (userProfileImage && images[0]) {
						images[0] = images[0].split(',')[1]  // remove annoying prefix
						if (images[0][0] in imageType)
							vcard += "PHOTO;ENCODING=BASE64;TYPE=" + imageType[images[0][0]] + ":" + images[0] + "\n"
					}
				} catch {}

				try {
					if (companyProfileImage && images[1]) {
						images[1] = images[1].replace('data:image/png;base64,', '')
						if (images[1][0] in imageType)
							vcard += "LOGO;ENCODING=BASE64;TYPE=" + imageType[images[1][0]] + ":" + images[1] + "\n"
					}
				} catch {}

				vcard += "END:VCARD"

				const blob = new Blob([vcard], { type: "text/vcard" });
				const url = URL.createObjectURL(blob);

				const newLink = document.createElement('a');
				newLink.download = contactName + ".vcf";
				newLink.textContent = contactName;
				newLink.href = url;
				newLink.click();
			})

			//return window.location.origin + "/redirect/user-profile/" + record_slug
		},
		/**
		* Returns a compiled object:
		* {
		* 	description: string,
		*	tasks: array
		*	materials: array
		*	equipment: array
		* }
		* 
		* worksheets param should be a collection of ServiceWorksheet or ChangeWorksheet models
		*/
		joinWorksheets(worksheets,job_num = "") {
			let vm = this

			let tasks = []
			let equipment = []
			let materials = []
			let workCompleted = []
			let serviceTasks = []

			if (worksheets) {
				worksheets.forEach(entry => {

					if (!("is_change_quote_work" in entry) || entry.is_change_quote_work == 0) {
						let entryTasks = "tasks_completed_json" in entry && vm.isValidJSON(entry.tasks_completed_json) ? JSON.parse(entry.tasks_completed_json) : []
						let entryMaterials = "parts_used_json" in entry && vm.isValidJSON(entry.parts_used_json) ? JSON.parse(entry.parts_used_json) : []
						let entryEquipment = "equipment_used_json" in entry && vm.isValidJSON(entry.equipment_used_json) ? JSON.parse(entry.equipment_used_json) : []
						let entryServiceTasks = "service_tasks_completed_json" in entry && vm.isValidJSON(entry.service_tasks_completed_json) ? JSON.parse(entry.service_tasks_completed_json) : []

						//add worksheet date to each task/material/equipment item
						entryTasks = entryTasks.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryMaterials = entryMaterials.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryEquipment = entryEquipment.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryServiceTasks = entryServiceTasks.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})

						tasks = tasks.concat(entryTasks)
						equipment = equipment.concat(entryEquipment)
						materials = materials.concat(entryMaterials)
						serviceTasks = serviceTasks.concat(entryServiceTasks)
					}

					let entryDate = vm.moment(entry.created_at).format("MMM DD")

					let workCompletedEntry = "<p><strong>"+entryDate+": #"+job_num+"</strong><br>"
					if ("CustomerAsset" in entry && entry.CustomerAsset)
						workCompletedEntry += "Asset: "+entry.CustomerAsset.description+" (S/N "+entry.CustomerAsset.serial_num+")</p>"

					workCompletedEntry += entry.work_completed_description

					workCompleted.push(workCompletedEntry)
				})
			}

			workCompleted = workCompleted.join("<hr>")

			//consolodate each section items
			tasks = vm.consolodateItems(tasks,["contract_id","item_number","description","task_id","unit_price"],"qty")
			serviceTasks = vm.consolodateItems(serviceTasks,["contract_id","item_number","description","task_id","unit_price"],"qty")
			equipment = vm.consolodateItems(equipment,["type_id"],"qty")
			materials = vm.consolodateItems(materials,["part_number","description","material_id"],"qty")

			return {
				description: workCompleted,
				tasks,
				materials,
				equipment,
				serviceTasks
			}
		},
		consolodateItems(items,fieldsToMatch,qtyField) {
			let consolodated = [], vm = this
			items.forEach(item => {
				let foundIndex = vm.findConsolodatedItemIndex(fieldsToMatch,item,consolodated)

				if (foundIndex >= 0) 
					consolodated[foundIndex][qtyField] += +item[qtyField]
				else 
					consolodated.push(item)
				
			})
			return consolodated
		},
		findConsolodatedItemIndex(fieldsToMatch, needleItem, haystackItems) {
			return haystackItems.findIndex(haystackItem => {
				let allFieldsMatch = true
				fieldsToMatch.forEach(key => {
					if (needleItem[key] != haystackItem[key]) 
						allFieldsMatch = false
				})

				if (allFieldsMatch)
					return true

				return false
			})
		}
	},
}